import { Box, Divider, Tab, Tabs, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { OnlinePanel } from './ContentPanels/OnlinePanel/OnlinePanel';
import { PsylarisPanel } from './ContentPanels/PsylarisPanel/PsylarisPanel';
import { UploadPanel } from './ContentPanels/UploadPanel/UploadPanel';
import { MediaModalStyle } from './style';
import MediaGlobe from '../../../assets/icons/media_globe.svg?react';
import MediaPsylaris from '../../../assets/icons/media_psylaris.svg?react';
import Upload from '../../../assets/icons/media_add_Item.svg?react';
import { MediaPanel } from '../../../commands/practitioner/enums/MediaPanel';
import useMediaContext from '../../../hooks/useMediaContextHook/useMediaContext';
import { useTranslation } from 'react-i18next';
import usePractitionerControlsContext from '../../../hooks/usePractitionerControlsContext/usePractitionerControlsContext';
import { SourceProjection } from '../../../commands/practitioner/enums/SourceProjection';

export function a11yProps(index: number, isVertical: boolean = false) {
  return {
    id: `${isVertical ? 'vertical' : 'simple'}-tab-${index}`,
    'aria-controls': `${isVertical ? 'vertical' : 'simple'}-tabpanel-${index}`,
  };
}

const MediaModal = () => {
  const [value, setValue] = React.useState(MediaPanel.OnlinePanel);
  const { t } = useTranslation();
  const { setSelectedItemURL } = useMediaContext();
  const { setProjectionType } = usePractitionerControlsContext();
  const handleChange = (event: React.SyntheticEvent, newValue: number): void => {
    setValue(newValue);
    setSelectedItemURL('');
  };

  useEffect(() => {
    if (value !== MediaPanel.OnlinePanel) {
      setProjectionType(SourceProjection.Flat);
    }
  }, [value]);

  const { mediaContainer } = MediaModalStyle;

  return (
    <Box sx={mediaContainer} data-testid="pwid-media-modal">
      <Box className={'main-tabs'}>
        <Box className={'left-title'}>
          <Typography variant="h6" className={'left-title_text'}>
            {t('media-modal-title-header')}
          </Typography>
        </Box>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="Vertical tabs example"
          orientation="vertical"
          variant="scrollable"
          className={'left-tab_container'}
        >
          <Tab
            icon={<MediaGlobe className={'left-tab_container-icon'} />}
            iconPosition="start"
            label={'Online'}
            data-testid="pwid-media-tab-online"
            {...a11yProps(MediaPanel.OnlinePanel, true)}
          />
          <Tab
            icon={<MediaPsylaris className={'left-tab_container-icon'} />}
            iconPosition="start"
            label={t('media-modal-left-tab-psylaris')}
            data-testid="pwid-media-tab-psylaris"
            {...a11yProps(MediaPanel.PsylarisLibrary, true)}
          />
          <Tab
            icon={<Upload className={'left-tab_container-icon'} />}
            iconPosition="start"
            label={t('upload-tab')}
            data-testid="pwid-media-tab-upload"
            {...a11yProps(MediaPanel.UploadPanel, true)}
          />
        </Tabs>
        <Divider variant="middle" />
      </Box>
      {value === MediaPanel.OnlinePanel && (
        <OnlinePanel className={'content-wrapper'} value={value} index={MediaPanel.OnlinePanel} />
      )}
      {value === MediaPanel.PsylarisLibrary && (
        <PsylarisPanel className={'content-wrapper'} value={value} index={MediaPanel.PsylarisLibrary} />
      )}
      {value === MediaPanel.UploadPanel && (
        <UploadPanel className={'content-wrapper'} value={value} index={MediaPanel.UploadPanel} />
      )}
    </Box>
  );
};

export default MediaModal;
